/**
 * Convert a listing into the four-prop shape expected by
 * <ListingPreviewModal>: { addressData, confirmedFields, photos, pricing }.
 */
export function toPreviewProps(listing) {
    return {
        addressData: listing.addressData ?? {},
        confirmedFields: listing.confirmedFields ?? {},
        photos: Array.isArray(listing.photos) ? listing.photos : [],
        pricing: listing.pricing ?? {},
    };
}
